module.exports = __webpack_public_path__ + "images/e6299e5cca85439e7e76694ed20aa477.png";